import * as elegiblePMsActionTypes from './actionTypes'
import { Eligibile } from './types'

export interface FetchElegiblePMsAction {
  payload: { currency: string }
  type: typeof elegiblePMsActionTypes.FETCH_ELEGIBLE_PMS_TYPE
}
export interface SetFetchingElegiblePMsAction {
  payload: { currency: string; fetching: boolean }
  type: typeof elegiblePMsActionTypes.SET_FETCHING_ELEGIBLE_PMS_TYPE
}
export interface SetFetchElegiblePMsErrorAction {
  payload: { currency: string; error: string }
  type: typeof elegiblePMsActionTypes.SET_FETCH_ELEGIBLE_ERROR_PMS_TYPE
}
export interface SetElegiblePMsAction {
  payload: { currency: string; data: Eligibile[] }
  type: typeof elegiblePMsActionTypes.SET_ELEGIBLE_PMS_TYPE
}
export type ElegiblePMsActionType =
  | FetchElegiblePMsAction
  | SetFetchingElegiblePMsAction
  | SetFetchElegiblePMsErrorAction
  | SetElegiblePMsAction

export const fetchElegiblePMs = (currency: string): ElegiblePMsActionType => ({
  payload: { currency },
  type: elegiblePMsActionTypes.FETCH_ELEGIBLE_PMS_TYPE
})
export const setFetchingElegiblePMs = (
  currency: string,
  fetching: boolean
): ElegiblePMsActionType => ({
  payload: { currency, fetching },
  type: elegiblePMsActionTypes.SET_FETCHING_ELEGIBLE_PMS_TYPE
})
export const setFetchElegiblePMsError = (
  currency: string,
  error: string
): ElegiblePMsActionType => ({
  payload: { currency, error },
  type: elegiblePMsActionTypes.SET_FETCH_ELEGIBLE_ERROR_PMS_TYPE
})
export const setElegiblePMs = (currency: string, data: Eligibile[]): ElegiblePMsActionType => ({
  payload: { currency, data },
  type: elegiblePMsActionTypes.SET_ELEGIBLE_PMS_TYPE
})
